import React, { useEffect } from 'react'
import { Layout } from 'antd'
import { useUser } from '../contexts/UserContext'
import { useCompany } from '../contexts/CompanyContext'
import { useConfig } from '../contexts/ConfigContext'
import { useSecureRequest } from '../hooks/useSecureRequest'
import { useParams, useHistory, useLocation } from 'react-router-dom'

// Layout Transversal
import SideBar from '../components/SideBar'
import TopBar from '../components/TopBar'

// Vistas
import DashboardView from '../components/views/DashboardView'
import CompaniesView from '../components/views/CompaniesView'
import ModulesView from '../components/views/ModulesView'
import PlansView from '../components/views/PlansView'
import UsersView from '../components/views/UsersView'
import SettingsView from '../components/views/SettingsView'
import RolesView from '../components/views/RolesView'

const { Content } = Layout

const adminNavOptions = [
  { key: 'dashboard', perm: 'admin.menu.sider.option.view.dashboard' },
  { key: 'companies', perm: 'admin.menu.sider.option.view.company_list' },
  { key: 'modules', perm: 'admin.menu.sider.option.view.module_list' },
  { key: 'plans', perm: 'admin.menu.sider.option.view.plan_list' },
  { key: 'users', perm: 'admin.menu.sider.option.view.user_list' },
  { key: 'roles', perm: 'admin.menu.sider.option.view.role_list' },
  { key: 'settings', perm: 'admin.menu.configurations.option.view.module_settings' },
]

function Index() {
  const { user } = useUser()
  const { config } = useConfig()
  const { updateCompanies } = useCompany()
  const { activeKey = 'dashboard' } = useParams<{ activeKey?: string }>()
  const { securePost } = useSecureRequest()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const views = user?.permissions?.views || []
    if (views.length > 0 && activeKey === 'dashboard' && !views.includes('admin.menu.sider.option.view.dashboard')) {
      const firstAvailable = adminNavOptions.find(opt => views.includes(opt.perm))
      if (firstAvailable) {
        history.replace({
          pathname: `/index/${firstAvailable.key}`,
          search: location.search
        })
      }
    }
  }, [user.permissions, activeKey, history, location.search])

  useEffect(() => {
    const fetchAllCompanies = async () => {
      if (user.adminScope === 'system' && config.key) {
        try {
          const res = await securePost('/company/list', { session: config.session })
          if (res && Array.isArray(res.companyList)) {
            updateCompanies({
              list: res.companyList
            })
          }
        } catch (err) {
          console.error('Error al cargar la lista completa de empresas:', err)
        }
      }
    }
    fetchAllCompanies()
  }, [user.adminScope, config.key, config.session, updateCompanies])

  const getPadding = () => {
    if (config.sideVisible && !config.isMobile) {
      if (config.sideCollapsed) {
        return 80
      } else {
        return 250
      }
    }
    if (config.sideVisible && config.isMobile) {
      return 80
    }
    return 0
  }

  const renderContent = () => {
    switch (activeKey) {
      case 'dashboard':
        return <DashboardView />
      case 'companies':
        return <CompaniesView />
      case 'modules':
        return <ModulesView />
      case 'plans':
        return <PlansView />
      case 'users':
        return <UsersView />
      case 'roles':
        return <RolesView />
      case 'settings':
        return <SettingsView />
      default:
        return <DashboardView />
    }
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {config.sideVisible && <SideBar activeKey={activeKey} />}
      <Layout style={{ paddingLeft: getPadding(), transition: '0.3s' }}>
        <TopBar />
        <Content style={{ margin: '16px', padding: 20, background: '#fff', minHeight: 'calc(100vh - 112px)', borderRadius: 12, overflowX: 'auto' }}>
          {renderContent()}
        </Content>
      </Layout>
    </Layout>
  )
}

export default Index
